import Vue from "vue";
import Vuex from "vuex";
import usuarioNamespace from "./modules/usuario"
import cocheNamespace from "./modules/coche"
import grupoNamespace from "./modules/grupo"
import clienteNamespace from "./modules/cliente"
import tareaNamespace from "./modules/tarea"
import reservaNamespace from "./modules/reserva"
import extraNamespace from "./modules/extra"
import precioExtraNamespace from "./modules/precioExtra"
import tarifasNamespace from "./modules/tarifas"
import temporadasNamespace from "./modules/temporadas"

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    usuarioNamespace,
    cocheNamespace,
    grupoNamespace,
    clienteNamespace,
    tareaNamespace,
    reservaNamespace,
    extraNamespace,
    precioExtraNamespace,
    tarifasNamespace,
    temporadasNamespace
  }
});
